<template>
  <layout-gestao>
    <header-list
      v-model="query"
      :title="pageTitle"
      :placeholderSearch="searchPlaceholder"
      :routeAddName="`${moduleCode}.${pageID}.create`"
      :canAdd="canAdd"
      :addTitle="addTitle"
      @search="onSearch"
    />

    <div class="row">
      <div class="col">
        <div id="accordion">
          <template v-for="(item, idx) in list">
            <div
              v-if="item.parent_id == null"
              :key="idx"
              class="card accordion"
            >
              <div class="card-header">
                <div class="row no-gutters">
                  <div
                    :id="'heading'+item.id"
                    class="col"
                    :class="{'tbl-column-disabled': !item.status}"
                    data-toggle="collapse"
                    :data-target="'#collapse'+item.id"
                    :aria-expanded="idx==0 && numTypes==1"
                    :aria-controls="'collapse'+item.id"
                  >
                    {{ item.name }}
                  </div>
                  <column-actions
                    v-if="checkActions"
                    tag="div"
                    class="col-auto d-flex justify-content-end"
                    listClass="actions"
                    :routeEdit="`${moduleCode}.${pageID}.show`"
                    :deleteMsgTemplate="$t(`${pageID}.form.group_delete`, {name: item.name})"
                    :canDetail="canDetail"
                    :canEdit="canEdit"
                    :canDelete="canDelete"
                    :row="item"
                    :index="idx"
                    :callbackDelete="onRemove"
                    @delete="deleteItem"
                  />
                </div>
              </div>
              <div
                :id="'collapse'+item.id"
                class="collapse"
                :class="{'show': idx==0 && numTypes==1}"
                :aria-labelledby="'heading'+item.id"
                data-parent="#accordion"
              >
                <div class="card-body">
                  <table-data
                    :data="item.childrens"
                    :settings="table.settings"
                    :columns="table.columns"
                    tableWrapperClass="table-responsive"
                    :inlineFilters="table.filters"
                    :autoUpdateFilter="table.autoUpdateFilter"
                    :addParamsToUrl="table.addParamsToUrl"
                    :loadingMsg="table.loadingMsg"
                    :notFoundMsg="table.notFoundMsg"
                    :orderByTemplate="table.orderByTemplate"
                    :showPagination="table.showPagination"
                    :tableInline="table.tableInline"
                    @error-load="showError"
                  >
                    <template #body="{row, index, remove}">
                      <td :class="[table.columns[0].class, {'tbl-column-disabled': !row.status}]">
                        {{ row.name }}
                      </td>
                      <column-actions
                        v-if="checkActions"
                        :routeEdit="`${moduleCode}.${pageID}.show`"
                        :canDetail="canDetail"
                        :canEdit="canEdit"
                        :canDelete="canDelete"
                        :row="row"
                        :index="index"
                        :callbackDelete="remove"
                        @delete="deleteItem"
                      />
                    </template>
                  </table-data>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </layout-gestao>
</template>

<script>
    import GeneralMixin from '../../../../mixin'

    export default {
        mixins: [GeneralMixin],
        data() {
            const pageID = 'parish_interventions_types';
            return {
                pageID: 'parish_interventions_types',
                pageTitle: this.$t(`${pageID}.title`),
                table: {
                    showPagination: false,
                    tableInline: true,
                    columns: [
                        {
                            label: this.$t(`${pageID}.model.name`),
                            field:  'name',
                            class: '',
                            sortable: true,
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions',
                        }
                    ],
                },
            }
        },
        computed: {
            numTypes() {
                return this.list.filter( item => item.parent_id==null).length;
            },
        },
        methods: {
            onRemove: function(id, data){
                if(data.index){
                    this.list.splice(data.index, 1);
                }
            },
        }
    }
</script>
